import React, { FunctionComponent, useEffect, useState, useCallback, memo } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { getVehicleParams } from './actions';
import useInfiniteScroll from '../../InfinityScroll/scrollHook';
import InfinityScroll from '../../InfinityScroll';
import { dataMapping } from './dataMapping';
import Onboarding from '../Onboarding';

import { Container } from './styles';

export interface Vehicle {
  vehicleNumber: string;
  fastagColor: string;
  lastTollName: string;
  lastTollTime: number;
  fastagAmount: number;
  autoRecharge: boolean;
  minBalance: number;
  vehicleId: number;
  tagClass: number;
  tagId: number;
}

const Vehicles: FunctionComponent<{ search?: string }> = memo(({ search }) => {
  const dispatch = useDispatch();
  const [page, setPage] = useState(0);

  const vehicles: Array<Vehicle> = useSelector((state: any) => state.fasTag.data.list);
  const totalCount: number = useSelector((state: any) => state.fasTag.data.totalCount);
  const isLoaded: boolean = useSelector((state: any) => state.fasTag.loaded);

  const [isFetching, setIsFetching] = useInfiniteScroll(fetchMoreVehicles);

  const dispatchToStore = useCallback((payload) => dispatch(getVehicleParams(payload)), [dispatch]);

  function fetchMoreVehicles() {
    if (vehicles && vehicles.length < totalCount) {
      const pageNo = page + 1;
      setPage(() => pageNo);
      dispatchToStore({ searchText: search, page: pageNo, noReset: true });
      setIsFetching(false);
    }
  }

  useEffect(() => {
    setPage(0);
    dispatchToStore({ searchText: search, page: 0, noReset: false });
    setIsFetching(false);
    // TODO: handle dependencies setIsFetching
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [search, dispatchToStore]);

  const dataList: any = dataMapping({ heading: `Vehicle (${totalCount || 0})` });

  return (
    <Container className="container">
      {isLoaded ? (
        !(vehicles && vehicles.length) && !search ? (
          <Onboarding />
        ) : (
          <InfinityScroll componentList={dataList} componentData={vehicles} loading={isLoaded} />
        )
      ) : (
        <InfinityScroll componentList={dataList} componentData={vehicles} loading={isLoaded} />
      )}
    </Container>
  );
});

export default Vehicles;
